import { render } from "./newBanner.vue?vue&type=template&id=7b6ae872&scoped=true"
import script from "./newBanner.vue?vue&type=script&lang=js"
export * from "./newBanner.vue?vue&type=script&lang=js"

import "./newBanner.vue?vue&type=style&index=0&id=7b6ae872&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src801691255/src/serverlesspressoV3/frontends/vue-order-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b6ae872"]])

export default __exports__